const parameters = {
  PublicPortalUrl: 'PublicPortalURL',
};

export default parameters;
